import { Field, ObjectType, ID, Float, InputType } from 'type-graphql'
import { Prop } from '@typegoose/typegoose'
import { ProductOperationCost } from './ProductOperationCost'
import { generateEntityId } from '../generateEntityId'

@ObjectType()
@InputType('ProductOperationInput')
export class ProductOperation {
  @Field(() => ID)
  @Prop({ type: String, default: () => generateEntityId('pop') })
  _id: string

  @Field(() => String)
  @Prop({ type: String })
  name: string

  @Field(() => ProductOperationCost)
  @Prop({ type: ProductOperationCost })
  cost: ProductOperationCost

  @Field(() => String)
  @Prop({ type: String })
  remarks: string

  @Field(() => Float)
  @Prop({ type: Number })
  total: number
}
